import { dataProps } from './properties'

export const setAttendanceEntryList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setAttendanceEntryData = (state, payload) => {
    state.props = payload.response
} 

export const resetAttendanceEntryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/attendanceEntry/mutations.js